export default __webpack_public_path__ + "static/media/ReactIcon.c2861c4d.png";